// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "545") return "js/vendors-090b667bb0546fa0.js";
if (chunkId === "691") return "js/vendor-super-form-dec3f60025462b41.js";
  // return url for filenames based on template
  return "js/" + {"94": "vendor-vega","960": "vendor-interrai-english",}[chunkId] + "-" + {"94": "200bff5849b2c427","960": "da34925ad7c4845b",}[chunkId] + ".chunk.js"
}